module.exports = __webpack_public_path__ + "media/country_flags/ca-60ab73ad.png";